// מביא את כל הקופונים של המשתמש
export async function fetchUserCoupons(userId) {
  const res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/coupons/${userId}`);
  if (!res.ok) throw new Error('שגיאה בשליפת קופונים');
  return res.json();
}

// החלת קופון על עגלה
export async function applyCoupon({ userId, couponCode, itemIds }) {
  const res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/coupons/apply`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ userId, couponCode, itemIds })
  });
  if (!res.ok) throw new Error('שגיאה בהחלת קופון');
  return res.json();
}

export default { fetchUserCoupons, applyCoupon };